import { ResponseError } from '../../errors/responseError';
import { fetchGetSuggestion, TGetSuggestionResponse } from '../../repositories/text-search/v2/get-suggestion';
import { IApplicationContext } from '../../types/redux/application';
import { ETelemetryEvents } from '../../types/telemetry';

const DEGRADATION_TELEMETRY_KEY = 'degradation.searchSuggestions';

type TFetchSuggestionParams = {
  text: string;
  jsonQuery?: object;
  geo?: string;
  isMap?: boolean;
};

export async function fetchSuggestion(
  context: IApplicationContext,
  { text, jsonQuery, geo, isMap = false }: TFetchSuggestionParams,
): Promise<string> {
  const { httpApi, logger, telemetry } = context;

  try {
    const { statusCode, response }: TGetSuggestionResponse = await fetchGetSuggestion({
      httpApi,
      parameters: {
        geo,
        jsonQuery,
        text,
      },
    });

    if (statusCode !== 200) {
      telemetry.increment(DEGRADATION_TELEMETRY_KEY);

      const responseError = new ResponseError({
        domain: 'services.fetchSuggestion',
        message: response.message || '',
        details: {
          // oxlint-disable-next-line typescript/no-explicit-any
          error: response.errors as any,
        },
      });

      logger.warning(responseError);
      throw responseError;
    }

    if (!response.suggestion?.queryString) {
      telemetry.increment(ETelemetryEvents.SearchSuggestionLinkFail);

      return '';
    }

    return `/${isMap ? 'map/' : 'cat.php'}?${response.suggestion.queryString}`;
  } catch (ex) {
    telemetry.increment(DEGRADATION_TELEMETRY_KEY);
    logger.error(ex);

    return '';
  }
}
